import script from "./msgWarnTable.vue?vue&type=script&setup=true&lang=js"
export * from "./msgWarnTable.vue?vue&type=script&setup=true&lang=js"

import "./msgWarnTable.vue?vue&type=style&index=0&id=b5aa4a4e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5aa4a4e"]])

export default __exports__